import './CheckmateDialogBase.scss';
import { FC } from "react";
import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton } from "@mui/material";
import { Close } from '@mui/icons-material';
import variables from '../../../assets/styles/variables.module.scss';


interface CheckmateDialogBaseProps extends DialogProps {
    title: string,
    modalContent: JSX.Element,
    actionButtons: JSX.Element,
    hideCloseIcon?: boolean,
    backgroundColor?: string,
    centerTitle?: boolean,
    titleClassName?: string
}

const CheckmateDialogBase: FC<CheckmateDialogBaseProps> = ({
    title, 
    modalContent, 
    actionButtons, 
    hideCloseIcon = false, 
    backgroundColor,
    centerTitle = false,
    titleClassName,
    ...dialogParams
}) => {

    const handleCloseModal = (e: any, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            // prevent click on background from dismissing all modals. or escape press
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        dialogParams.onClose && dialogParams.onClose(e, reason);
    }

    return <Dialog scroll="paper" {...dialogParams} sx={[
        ...(dialogParams.sx ? [dialogParams.sx] : []),
        {
            '& .MuiPaper-root': {
                backgroundColor: backgroundColor || (process.env.REACT_APP_SKIN_NAME === 'atai' ? variables.color_new_background : variables.color_background_grey),
                backgroundImage: 'none',
                color: process.env.REACT_APP_SKIN_NAME === 'atai' ? variables.color_on_background : "default",
            },
        },
    ]} onClose={handleCloseModal}>
        <DialogTitle className={`modal-title ${titleClassName || ''}`} sx={{
            padding: variables.spacing_standard, 
            margin: 0,
            textAlign: centerTitle ? 'center' : 'left'
        }}>
            {title}
            {!hideCloseIcon && <IconButton onClick={dialogParams.onClose as any} sx={{ position: 'absolute', right: variables.spacing_standard, top: variables.spacing_standard, padding: 0, color: process.env.REACT_APP_SKIN_NAME === 'atai' ? variables.color_on_background : "default"}}><Close /></IconButton>}
        </DialogTitle>
        <DialogContent sx={{padding: 0, margin: 0}}>
            {modalContent}
        </DialogContent>
        <DialogActions sx={{padding: variables.spacing_standard, margin: 0}}>
            {actionButtons}
        </DialogActions>
    </Dialog>
}

export default CheckmateDialogBase;